const IDEMPOTENT_REQUEST_METHODS = ['get', 'head', 'options']

export function isIdempotentRequestMethod(method: string): boolean {
  return IDEMPOTENT_REQUEST_METHODS.includes(method.toLowerCase())
}
